import { Guid } from "@/Common/Models/Guid";

class PreventiveCareCriteria {
    public Id: Guid;
    public AgeFrom: number;
    public AgeTo: number;
    public GenderLookupIds: Guid[];
    public ExclusionBillingCode: string;
    public NameLookupId: Guid;
    public EligibleForBonus: boolean;

    public constructor(init?: Partial<PreventiveCareCriteria>) {
        Object.assign(this, init);
    }

    public getTranslatedName(): string {
        return cacheStore.GetLocalizedValueByLookupId(this.NameLookupId);
    }
}

export { PreventiveCareCriteria };
